import React, { useState } from "react";
import { ReactComponent as CheckIcon } from "../../../../../assects/svg/client_details/check-circle.svg";
import { ReactComponent as CrossIcon } from "../../../../../assects/svg/client_details/cross-circle.svg";
import { ReactComponent as ArrowUpRight } from "../../../../../assects/svg/client_details/ArrowUpRight.svg";
import Drawer from "./Drawer";
import { Medicine } from "../../../hooks/useAllLogsData";

interface MedicineCardProps {
  medicines: Medicine[];
  selectedDate?: string;
}

const MedicineCard: React.FC<MedicineCardProps> = ({ medicines, selectedDate }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const formatTime = (hour: number, minute: number, period: string): string => {
    const paddedHour = hour.toString().padStart(2, "0");
    const paddedMinute = minute.toString().padStart(2, "0");
    return `${paddedHour}:${paddedMinute} ${period}`;
  };

  const renderMedicineEntry = (medicine: Medicine) => {
    const isTaken = medicine.status === "1";
    const time = formatTime(medicine.hour, medicine.minute, medicine.period);

    // =========================================================================
    // OLD: medicine.when_to_take, medicine.meal_type
    const instruction = `${medicine.when_to_take} ${medicine.meal_type.toLowerCase()}`;
    //
    // NEW: medicine.before_after_meal, medicine.meal_type
    // const instruction = `${medicine.before_after_meal} ${medicine.meal_type.toLowerCase()}`;
    // =========================================================================

    return (
      <div className="flex items-start gap-2">
        {isTaken ? (
          <CheckIcon className="w-5 h-5 3xl:w-6 3xl:h-6 flex-shrink-0" />
        ) : (
          <CrossIcon className="w-5 h-5 3xl:w-6 3xl:h-6 flex-shrink-0" />
        )}
        <div className="flex-1">
          <p className="text-[12px] 3xl:text-sm font-medium font-inter text-[#1F1F1F]">
            {medicine.medicine_name}{" "}
            <span className="text-[10px] 3xl:text-[12px] font-medium font-inter text-[#8D8D8D]">
              • {time}
            </span>
          </p>
          <p className="text-[10px] 3xl:text-[12px] font-medium font-inter text-[#8D8D8D]">
            {instruction}
          </p>
        </div>
      </div>
    );
  };

  const displayedMedicines = medicines.slice(0, 2);

  if (!medicines || medicines.length === 0) {
    return (
      <div className="bg-white rounded-md shadow-sm p-4 flex flex-col h-full">
        <h3 className="text-[12px] 3xl:text-sm font-semibold font-inter text-[#1F1F1F] uppercase mb-4">
          MEDICINE
        </h3>
        <div className="flex-1 flex items-center justify-center">
          <p className="text-sm font-medium text-[#646464] font-inter">No entries yet</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div onClick={() => setIsDrawerOpen(true)} className="bg-white rounded-md shadow-sm p-4 flex flex-col h-full cursor-pointer">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-[12px] 3xl:text-sm font-semibold font-inter text-[#1F1F1F] uppercase">
            MEDICINE
          </h3>
          <button
            
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="View all medicines"
          >
            <ArrowUpRight className="w-4 h-4 3xl:w-5 3xl:h-5 text-[#1F1F1F]" />
          </button>
        </div>

        <div>
          {displayedMedicines.map((medicine, index) => (
            <React.Fragment key={index}>
              {renderMedicineEntry(medicine)}
              {index < displayedMedicines.length - 1 && (
                <div className="w-full border-t border-gray-200 my-2.5"></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      <Drawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title="Medicine"
        selectedDate={selectedDate}
      >
        <div className="space-y-3">
          {medicines.map((medicine, index) => (
            <div key={index} className="pb-3 border-b border-gray-100">
              {renderMedicineEntry(medicine)}
            </div>
          ))}
        </div>
      </Drawer>
    </>
  );
};

export default MedicineCard;